import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { NgForm } from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { PSPPatient } from 'src/app/_models/PSP/psp-patient.model';
import { LookupModalService } from 'src/app/_services/PSP/modals.service';
import { PSPPatientService } from 'src/app/_services/PSP/patient.service';

@Component({
  selector: 'app-fetch-user-data-modal',
  templateUrl: './fetch-user-data-modal.component.html',
  styleUrls: ['./fetch-user-data-modal.component.scss'],
})
export class FetchUserDataModalComponent implements OnInit, OnDestroy {
  userExists?: boolean = null;
  loading = false;
  user?: PSPPatient;
  notificationModal: BsModalRef;
  @ViewChild('modalNotification') modalNotification: any;
  isFirstFetch = true;
  phone: {digitOne: string, digitTwo: string, digitThree: string} = {
    digitOne: null,
    digitTwo: null,
    digitThree: null
  };

  @Output() fetchData: EventEmitter<PSPPatient> = new EventEmitter();

  notification = {
    keyboard: true,
    class: 'modal-dialog-centered modal-black',
  };

  constructor(
    private pspPatientService: PSPPatientService,
    private modalService: BsModalService,
    private myModalService: LookupModalService
  ) {}

  ngOnDestroy(): void {
    window.location.reload();
  }

  ngOnInit(): void {
    this.myModalService.lookupModal.subscribe((res) => {
      if (!res || this.modalService.getModalsCount() !== 0) {
        return;
      }

      this.notificationModal = this.modalService.show(
        this.modalNotification,
        this.notification
      );
    });
  }

  onDigitInput(event: any): void {
    let element: any;

    if (event.code !== 'Backspace') {
      element = event.target.nextElementSibling;
    }

    if (event.code === 'Backspace') {
      element = event.target.previousElementSibling;
      if (event.target.value.length === 0) {
        element?.focus();
        return;
      }
    }

    if (
      element == null ||
      event.target.value.length !== event.target.maxLength
    ) {
      return;
    } else {
      element?.focus();
    }
  }

  onSubmit(form: NgForm): void {
    if (this.userExists && this.user) {
      this.fetchData.emit(this.user);
      this.notificationModal.hide();
      this.isFirstFetch = false;

      return;
    }

    if (this.userExists === false){
      this.onReset(form);
      this.notificationModal.hide();

      return;
    }

    const phoneNumber = this.buildPhoneNumber(form);

    this.loading = true;

    this.pspPatientService
      .getPatientByPhone({ Phone: phoneNumber })
      .subscribe((res) => {
        this.user = res.data;
        this.loading = false;

        this.userExists = res.data === null ? false : true;
      });
  }

  private buildPhoneNumber(form: NgForm): string {
    let num: string;

    for (const key in form.value) {
      if (Object.prototype.hasOwnProperty.call(form.value, key)) {
        num = num ? num + form.value[key] : form.value[key];
      }
    }

    return num;
  }

  onReset(form: NgForm): void {
    form.reset();

    this.user = null;
    this.userExists = null;
    this.isFirstFetch = true;
  }

  getActionLabel(): string {
    if (this.userExists) {
      return 'Fetch User Data';
    }

    if (this.userExists === false) {
      return 'Close';
    }

    return 'Search';
  }

  closeFetchDataModal(form: NgForm): void {
    this.onReset(form);

    this.notificationModal.hide();
  }
}
